import { ShoppingCartIcon } from 'cat-ecommerce-alloy';
import styles from './CustomizeModalTable.module.scss';
import PropTypes from 'prop-types';

function CartIcon({ quantityInCart, isSM }) {
  return !isSM ? (
    <div className="mt-2 position-relative">
      <ShoppingCartIcon
        className={`${styles['shopping-cart-icon']}`}
        height="28"
        width="28"
      />
      <p
        className={`m-0 text-xxxs text-center rounded-circle ${styles['shopping-cart-icon__item-count-mobile']}`}
      >
        {quantityInCart}
      </p>
    </div>
  ) : (
    <div className="mt-1 position-relative">
      <ShoppingCartIcon
        height="22"
        width="22"
        className={`d-lg-inline min-width-20px ${styles['shopping-cart-icon']}`}
      />
      <p
        className={`m-0 text-xxxs text-center rounded-circle ${styles['shopping-cart-icon__item-count']}`}
      >
        {quantityInCart}
      </p>
    </div>
  );
}

CartIcon.propTypes = {
  quantityInCart: PropTypes.number,
  isSM: PropTypes.bool
};

export default CartIcon;
